// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"195":"primary","761":"Vendor"}[chunkId] + ".epic-web-esport-site-" + {"195":"cbe55a538a2b6fcd8b52","761":"51acfc4627d139c9bcd6"}[chunkId] + ".css";
};